<template>
  <div
    class="v-pagination-bar__wrapper"
    :class="{ ['inactive']: isLoading }"
    v-if="(totalItems > 25 && itemsPerPage > 25 || totalPages > 1 ) && !isLoading"
  >
    <div class="psw-limit-wrapper">
      <VSelect
        v-if="totalItems > 25 || totalPages > 1"
        :options="_pageLimits"
        :value="itemsPerPage"
        :canSelect="_pageLimits.length > 1"
        extra-class="pagination-wrapper-select"
        dropDownWidth="fitContent"
        position="up"
        layout="auto"
        type="alternate"
        selectIcon="chevron-down"
        @select="(e, val) => _onChangePageLimit(e, val)"
      ></VSelect>
    </div>

    <VPagination
      v-if="_displayPagination"
      :totalItems="totalItems"
      :currentPage="currentPage"
      :itemsPerPage="itemsPerPage"
      :totalPages="totalPages"
      classType="primary"
      @change="paginate"
    ></VPagination>

    <VPageSwitcher
      v-if="_displayPagination"
      :totalItems="totalItems"
      :totalPages="totalPages"
      :itemsPerPage="itemsPerPage"
      @change="paginate"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// components
import VPagination from "@/components/VPagination";
import VPageSwitcher from "@/components/VPageSwitcher";
import VSelect from "@/components/VSelect";

const _defaultPageItemLimits = [
  {
    value: 25,
    label: "25 per page",
    selectLabel: "25",
    key: 25
  },
  {
    value: 50,
    label: "50 per page",
    selectLabel: "50",
    key: 50
  },
  {
    value: 100,
    label: "100 per page",
    selectLabel: "100",
    key: 100
  }
];

export default Vue.component("VPaginationBar", {
  props: {
    totalItems: VueTypes.number,
    itemsPerPage: VueTypes.number,
    currentPage: VueTypes.number,
    totalPages: VueTypes.number,
    pageLimits: VueTypes.arrayOf(
      VueTypes.shape({
        value: VueTypes.any,
        label: VueTypes.string,
        selectLabel: VueTypes.string,
        key: VueTypes.any
      })
    ).def(_defaultPageItemLimits),
    isLoading: VueTypes.bool.def(false)
  },

  components: {
    VPagination,
    VPageSwitcher,
    VSelect
  },

  methods: {
    _onChangePageLimit(e, item) {
      this.$emit("pageLimitUpdated", item);
    },

    paginate(page) {
      this.$emit("paginate", page);
    }
  },

  computed: {
    _total() {
      return this.totalPages
        ? this.totalPages * this.itemsPerPage
        : this.totalItems;
    },

    _displayPagination() {
      return (this._total > this.itemsPerPage) || this.totalPages > 1;
    },

    _pageLimits() {
      return _defaultPageItemLimits;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-pagination-bar";

.#{$ns}__wrapper {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $main-body-color;
  font-size: 14px;
  height: 72px;
  min-height: 72px;
  position: fixed;
  width: calc(100% - #{$sidebar-width});
  left: $sidebar-width;
  padding: 0 $general-padding 0 40px;
  border-radius: 4px 4px 4px 10px;

  &:hover {
    i {
      color: $primary-color;
    }
  }

  &.inactive {
    pointer-events: none;
    opacity: 0.5;
  }

  .psw-limit-wrapper {
    display: flex;
    align-items: baseline;

    /deep/ .v-select__current-value {
      span {
        color: $secondary-text-color;
        line-height: 1.2;
      }

      i {
        color: $primary-grey;
        margin-left: 5px;
        font-size: 15px;
        margin-top: 4px;
      }
    }
  }

  @media screen and (max-width: 991px) {
    width: 100%;
    left: 0;
    /* flex-direction: column; */

    .psw-limit-wrapper {
      margin-left: 0;
      margin-bottom: 10px;
    }

    .v-page-switcher__wrapper {
      margin-top: 10px;
    }
  }
}
</style>

<style lang="scss">
.v-select__wrapper.pagination-wrapper-select {
  .v-select__current-value {
    font-size: 14px;
    padding: 8px 10px;
  }
}
</style>
